import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import { FCFieldEffect } from '../form-config.interface';
import {
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_COUPON_DAY_COUNT,
  PAYOFF_COUPON_FIXED_RATE,
  PAYOFF_COUPON_FREQUENCY,
  PAYOFF_COUPON_TYPE,
  PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
  PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
  PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
  PAYOFF_PARTICIPATION_BASE_CAPPED,
  PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP,
  PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
  PAYOFF_PARTICIPATION_BASE_LEVERAGE,
  PAYOFF_PARTICIPATION_BASE_STRIKE,
  PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
  PAYOFF_PARTICIPATION_CAPITAL_BASE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_FREQUENCY,
  SUMMARY_PERFORMANCE_TYPE,
  SUMMARY_SETTLEMENT_TYPE,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { EMPTY_PRODUCT_SETTINGS } from './empty-product.settings';

export const DROPBACK_CERTIFICATE_SETTINGS: {
  id: ProductTypeEnum;
  label: string;
  effects: FCFieldEffect[];
} = {
  id: ProductTypeEnum.DROPBACK_CERTIFICATE,
  label: 'Drop-Back Certificate',
  effects: [
    ...EMPTY_PRODUCT_SETTINGS.effects,
    {
      formControlNames: [SUMMARY_SETTLEMENT_TYPE],
      selectValues: ['CASH_OR_PHYSICAL'],
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: ['SINGLE'],
      readOnly: true,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_FIXED_RATE],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: ['FIXED'],
      readOnly: true,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_FREQUENCY, SUMMARY_FREQUENCY],
      readOnly: false,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_DAY_COUNT],
      selectValues: ['BOND_BASIS_30_360'],
      readOnly: false,
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_PARTICIPATION_BASE_TYPE],
      selectValues: ['DROPBACK_CERTIFICATE'],
      readOnly: true,
      hidden: true,
    },
    {
      formControlNames: [
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
      ],
      selectValues: ['NONE'],
      hidden: true,
    },
    {
      formControlNames: [
        PAYOFF_CALLABILITY_CALLABILITY,
        PAYOFF_PARTICIPATION_CAPITAL_BASE,
        PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT,
        PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE,
        PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION,
        PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP,
        PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR,
        PAYOFF_PARTICIPATION_BASE_CAPPED,
        PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL,
        PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK,
        PAYOFF_PARTICIPATION_BASE_STRIKE,
        PAYOFF_PARTICIPATION_BASE_LEVERAGE,
      ],
      hidden: true,
    },
  ],
};
